export default __webpack_public_path__ + "static/media/sb.08d8e474.jpeg";